import React from "react";
import { Layout, Button, Card, Form, Input, Select, Tooltip, Cascader, Switch } from "element-react";
import { useHistory } from "react-router-dom";
import WizardLeftMenu from "./wizardLeftMenu";

import MyComponentCard from "../MyComponentCard"; // importación del componente card
import factoryIcon from "../../assets/imgs/imageFactories.png" // ruta a la imagen
import retailers from '../../assets/imgs/imageRetailers.png';
import tradingCompany from '../../assets/imgs/imageTradingCompany.png';
import finalCustomer from '../../assets/imgs/imageFinalCustomer.png'
import wholesalers from '../../assets/imgs/imageWholesalers.png';

export default function WizardNgStep1({
  handleNextStep, handlePrevStep, step, formInputs, setFormInputs, t, form1, rules1, type, yearOptions, revenue,
  tooltopImage, options2, loadSubCategories, handleSaveMyStore
}) {



  return (
    <Layout.Row>
      <WizardLeftMenu step={step} />
      <Layout.Col xs="23" sm="23" md="20" lg="20">
        <Card className='box-card'>
          <div className='create-store-title'>
            <h1>3. Experience Information</h1>
          </div>
          <h4>Additional Information</h4>
          <Form ref={form1} model={formInputs} className="en-US mt-2" rules={rules1} label-position="top">
            <Layout.Row>
              <Layout.Col xs="24" sm="24" md="24" lg="24">
                <Form.Item label={t('my-store.create.form.featured_category')} prop="featured_category">
                  <Tooltip placement="top-start" content="What's the category of the main product offered by your company?" effect="light"> <img className="tooltip-img" height={'20'} src={tooltopImage}></img></Tooltip>
                  {
                    <Cascader className="cascader-add-product"
                      options={options2}
                      value={Array.isArray(formInputs.featured_category) ? formInputs.featured_category : []}
                      onChange={(v) => { loadSubCategories(v) }}
                    />
                  }
                </Form.Item>
              </Layout.Col>
            </Layout.Row>
            <Layout.Row>
              <Layout.Col xs="24" sm="24" md="24" lg="24">
                <label className="inline-block">Name at least 1 product you want to promote (use generic product names)</label> <Tooltip className="inline-block" placement="top-middle" content="Examples: Stainless Steel Furniture, Circuit Boards, Degreaser, Cardboar Box, Plastic Resin" effect="light"> <img className="tooltip-img" height={'20'} src={tooltopImage}></img></Tooltip>
              </Layout.Col>
            </Layout.Row>
            <Layout.Row>
              <Layout.Col xs="24" sm="24" md="24" lg="12">
                <Form.Item label={'1'} prop="promote1">
                  <Input
                    maxlength={120}
                    value={formInputs.promote1}
                    onChange={(v) => { setFormInputs({ ...formInputs, promote1: v }) }}
                  />
                </Form.Item>
              </Layout.Col>
            </Layout.Row>
            <Layout.Row>
              <Layout.Col xs="24" sm="8" lg="12">
                <Form.Item label={'2'} prop="promote2">
                  <Input
                    maxlength={120}
                    value={formInputs.promote2}
                    onChange={(v) => { setFormInputs({ ...formInputs, promote2: v }) }}
                  />
                </Form.Item>
              </Layout.Col>
            </Layout.Row>
            <Layout.Row>
              <Layout.Col xs="24" sm="8" md="24" lg="12">
                <Form.Item label={'3'} prop="promote3">
                  <Input
                    maxlength={120}
                    value={formInputs.promote3}
                    onChange={(v) => { setFormInputs({ ...formInputs, promote3: v }) }}
                  />
                </Form.Item>
              </Layout.Col>
            </Layout.Row>
            {/* <Layout.Row>
              <Layout.Col xs="24" sm="8" md="24" lg="12">
                <Form.Item label={'4'} prop="promote4">
                  <Input
                    maxlength={120}
                    value={formInputs.promote4}
                    onChange={(v) => { setFormInputs({ ...formInputs, promote4: v }) }}
                  />
                </Form.Item>
              </Layout.Col>
            </Layout.Row>  */}
            <Layout.Row> 
              <Layout.Col xs="24" sm="24" md="24" lg="24">
                <label>Name at least one manufacturing process your company specializes in</label> <Tooltip className="inline-block" placement="top-middle" content="Examples: Plastic injection, CNC Machining, Printing, Laser Engraving" effect="light"> <img className="tooltip-img" height={'20'} src={tooltopImage}></img></Tooltip>
              </Layout.Col>
            </Layout.Row>
            <Layout.Row>
              <Layout.Col xs="24" sm="8" md="24" lg="12">
                <Form.Item label={'1'} prop="process1">
                  <Input
                    maxlength={120}
                    value={formInputs.process1}
                    onChange={(v) => { setFormInputs({ ...formInputs, process1: v }) }}
                  />
                </Form.Item>
              </Layout.Col>
            </Layout.Row>
            <Layout.Row>
              <Layout.Col xs="24" sm="8" md="24" lg="12">
                <Form.Item label={'2'} prop="process2">
                  <Input
                    maxlength={120}
                    value={formInputs.process2}
                    onChange={(v) => { setFormInputs({ ...formInputs, process2: v }) }}
                  />
                </Form.Item>
              </Layout.Col>
            </Layout.Row>
            <Layout.Row>
              <Layout.Col xs="24" sm="8" md="24" lg="12">
                <Form.Item label={'3'} prop="process3">
                  <Input
                    maxlength={120}
                    value={formInputs.process3}
                    onChange={(v) => { setFormInputs({ ...formInputs, process3: v }) }}
                  />
                </Form.Item>
              </Layout.Col>
            </Layout.Row>
            <Layout.Row>
              <Layout.Col>
                <Layout.Row>
                  <div>
                    <h4>About your market</h4>
                    <label className="inline-block">Let us know what kind of customer you are looking for (you can select more than one).</label> <Tooltip className="inline-block" placement="top-middle" content="What kind of customer you want to reach through Bainub? Multiple selection is allowed" effect="light"> <img className="tooltip-img" height={'20'} src={tooltopImage}></img></Tooltip>
                  </div>

                </Layout.Row>
                <Layout.Row className="mt-2">
                  <div className='select-box'>
                    <Layout.Col xs="24" sm="12" md="8" lg="4">
                      {/* <Switch
                        onText="YES"
                        offText="NO"
                        value={formInputs.about_market1 == 'true' || formInputs.about_market1 ? true : false}
                        allowFocus={false}
                        onChange={(v) => { setFormInputs({ ...formInputs, about_market1: v }); console.log('Switch :: ' + v) }}
                      /> */}
                      <MyComponentCard
                          seleccionado={formInputs.about_market1 == 'true' || formInputs.about_market1 == true ? true : false}
                          onSeleccionar={(newValue) => {
                              setFormInputs({ ...formInputs, about_market1: newValue });
                              console.log('about_market1:', newValue);
                          }}
                          image={factoryIcon}
                          altText="Factories Icon"
                          cardText="Factories"
                      />
                    </Layout.Col>
                    <Layout.Col xs="12" sm="12" md="8" lg="4">
                      {/* <Switch
                        onText="YES"
                        offText="NO"
                        value={formInputs.about_market2 || formInputs.about_market2 == 'true' ? true : false}
                        allowFocus={false}
                        onChange={(v) => { setFormInputs({ ...formInputs, about_market2: v }); console.log('Switch :: ' + v) }}
                      /> */}
                      <MyComponentCard
                          seleccionado={formInputs.about_market2 == 'true' || formInputs.about_market2 == true ? true : false}
                          onSeleccionar={(newValue) => {
                              setFormInputs({ ...formInputs, about_market2: newValue });
                              console.log('about_market2:', newValue);
                          }}
                          image={retailers}
                          altText="Retailer Icon"
                          cardText="Retailers"
                      />
                    </Layout.Col>
                    <Layout.Col xs="12" sm="12" md="8" lg="4">
                      {/* <Switch
                        onText="YES"
                        offText="NO"
                        value={formInputs.about_market3 == 'true' || formInputs.about_market3 ? true : false}
                        allowFocus={false}
                        onChange={(v) => { setFormInputs({ ...formInputs, about_market3: v }); console.log('Switch :: ' + v) }}
                      /> */}
                      <MyComponentCard
                          seleccionado={formInputs.about_market3 == 'true' || formInputs.about_market3 == true ? true : false}
                          onSeleccionar={(newValue) => {
                              setFormInputs({ ...formInputs, about_market3: newValue });
                              console.log('about_market3:', newValue);
                          }}
                          image={tradingCompany}
                          altText="Trading Company Icon"
                          cardText="Trading Company"
                      />
                    </Layout.Col>
                    <Layout.Col xs="12" sm="12" md="8" lg="4">
                      {/* <Switch
                        onText="YES"
                        offText="NO"
                        value={formInputs.about_market4 == 'true' || formInputs.about_market4 ? true : false}
                        allowFocus={false}
                        onChange={(v) => { setFormInputs({ ...formInputs, about_market4: v }); console.log('Switch :: ' + v) }}
                      /> */}
                      <MyComponentCard
                          seleccionado={formInputs.about_market4 == 'true' || formInputs.about_market4 == true ? true : false}
                          onSeleccionar={(newValue) => {
                              setFormInputs({ ...formInputs, about_market4: newValue });
                              console.log('about_market4:', newValue);
                          }}
                          image={finalCustomer}
                          altText="Final customer Icon"
                          cardText="Final customer"
                      />
                    </Layout.Col>
                    <Layout.Col xs="12" sm="12" md="8" lg="4">
                      {/* <Switch
                        onText="YES"
                        offText="NO"
                        value={formInputs.about_market5 == 'true' || formInputs.about_market5 ? true : false}
                        allowFocus={false}
                        onChange={(v) => { setFormInputs({ ...formInputs, about_market5: v }); console.log('Switch :: ' + v) }}
                      /> */}
                      <MyComponentCard
                          seleccionado={formInputs.about_market5 == 'true' || formInputs.about_market5 == true ? true : false}
                          onSeleccionar={(newValue) => {
                              setFormInputs({ ...formInputs, about_market5: newValue });
                              console.log('about_market5:', newValue);
                          }}
                          image={wholesalers}
                          altText="Wholesalers Icon"
                          cardText="Wholesalers"
                      />
                    </Layout.Col>
                  </div>
                </Layout.Row>


              </Layout.Col>
            </Layout.Row>
            <Layout.Row>
              <Layout.Col className='mt-2'>
                <Button type="secondary" onClick={handlePrevStep}>
                  Go back
                </Button>
                <Button type="primary" onClick={handleNextStep}>
                  {t('my-store.create.form.button-next')}
                </Button>
              </Layout.Col>
            </Layout.Row>
          </Form>
        </Card>
      </Layout.Col>
    </Layout.Row>
  );
}